<div class="service-modal-container">

  <div class="modal-header">
    <div class="title-group">
      <div class="icon-box">
        <mat-icon>settings</mat-icon>
      </div>
      <div class="title-text">
        <h2>Service Status Settings</h2>
        <span class="subtitle">Configure service dates and maintenance details</span>
      </div>
    </div>
    <button mat-icon-button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body" [formGroup]="form">

    <div *ngIf="loading" class="loading-state">
      <div class="loading-spinner-container">
        <mat-spinner diameter="40"></mat-spinner>
        <span class="loading-text">Loading settings...</span>
      </div>
    </div>

    <div *ngIf="!loading" class="form-container">

      <!-- Service Dates Section -->
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon dates">
            <mat-icon>event</mat-icon>
          </div>
          <span class="section-title">Service Dates</span>
        </div>
        
        <div class="form-grid-row">
          <div class="form-field-group">
            <label class="custom-label lbl-time">
              <mat-icon>history</mat-icon> Last Service Date
            </label>
            <mat-form-field appearance="outline">
              <input matInput [matDatepicker]="lastPicker" formControlName="last_service_date" [max]="today" placeholder="Select date">
              <mat-datepicker-toggle matIconSuffix [for]="lastPicker"></mat-datepicker-toggle>
              <mat-datepicker #lastPicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="form-field-group">
            <label class="custom-label lbl-date">
              <mat-icon>event_upcoming</mat-icon> Next Service Date
            </label>
            <mat-form-field appearance="outline">
              <input matInput [matDatepicker]="nextPicker" formControlName="next_service_date" [min]="today" placeholder="Select date">
              <mat-datepicker-toggle matIconSuffix [for]="nextPicker"></mat-datepicker-toggle>
              <mat-datepicker #nextPicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Service Information Section -->
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon info">
            <mat-icon>handyman</mat-icon>
          </div>
          <span class="section-title">Service Information</span>
        </div>

        <div class="form-grid-row">
          <div class="form-field-group">
            <label class="custom-label lbl-cat">
              <mat-icon>category</mat-icon> Service Category
            </label>
            <mat-form-field appearance="outline">
              <mat-select formControlName="service_category" placeholder="Select service category">
                <mat-option *ngFor="let cat of serviceCategories" [value]="cat">{{ cat }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-field-group">
            <label class="custom-label lbl-type">
              <mat-icon>engineering</mat-icon> Last Service Performed
            </label>
            <mat-form-field appearance="outline">
              <mat-select formControlName="last_service_performed" placeholder="Select service type">
                <mat-option *ngFor="let type of serviceTypes" [value]="type">{{ type }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="form-field-group">
          <label class="custom-label lbl-person">
            <mat-icon>badge</mat-icon> Service Performed By
          </label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="service_performed_by" placeholder="Enter technician name or company">
          </mat-form-field>
        </div>
      </div>

      <!-- Service Details Section -->
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon details">
            <mat-icon>article</mat-icon>
          </div>
          <span class="section-title">Service Details</span>
        </div>

        <div class="form-field-group">
          <label class="custom-label lbl-desc">
            <mat-icon>notes</mat-icon> Description & Notes
          </label>
          <mat-form-field appearance="outline" class="textarea-field">
            <textarea matInput formControlName="service_detail" rows="4" placeholder="Enter detailed description of the service performed..."></textarea>
          </mat-form-field>
          <p class="hint-text">
            <mat-icon>lightbulb</mat-icon>
            Provide comprehensive details about the service for future reference
          </p>
        </div>
      </div>

    </div>
  </div>

  <div class="modal-footer">
    <div class="footer-content">

      <div class="status-indicator">
        <div *ngIf="hasChanges" class="unsaved-changes">
          <div class="pulse-dot"></div>
          <mat-icon>edit_note</mat-icon>
          <span>Unsaved changes</span>
        </div>
      </div>

      <div class="action-buttons">
        <button mat-stroked-button class="cancel-btn" (click)="close()" [disabled]="updating">
          <mat-icon>close</mat-icon>
          Cancel
        </button>
        <button mat-flat-button class="save-btn" (click)="handleUpdate()" [disabled]="updating || !hasChanges">
          <div class="btn-save-content">
            <mat-spinner *ngIf="updating" diameter="16" color="accent"></mat-spinner>
            <mat-icon *ngIf="!updating">check_circle</mat-icon>
            <span>{{ updating ? 'Saving...' : 'Save Changes' }}</span>
          </div>
        </button>
      </div>

    </div>
  </div>
</div>
